import React from "react";
import { ContentFormatter } from "@ebscois/react-component-library";
import GenericTable from "../../GenericTable";
import { affordances } from "../../../util/analytics";
import { StyledTableForPrint } from "./_styled";

const tableProcessor = ({ setIsDialogOpen, setTableData }) => {
  const processTable = (node, { children = null, tablesContent = {} }) => {
    const tableId = node.attribs["data-id"];
    const isStandAlone = node.attribs["data-is-standalone"] === "true";
    const dataTitle = node.attribs["data-title"];
    const tableXHTML = tablesContent[tableId];

    let tableText = "Table";
    let tableCaption = "";
    let tableAnchorText = [];

    if (dataTitle) {
      tableAnchorText = dataTitle.split(/^([Tt]able\s?\d+).?\s?(.*)$/);
    }

    if (tableAnchorText.length === 1) {
      tableText = tableAnchorText[0];
    }

    if (tableAnchorText.length > 1) {
      tableText = `${tableAnchorText[1]}.`;
      tableCaption = tableAnchorText.slice(2).join(".").slice(0, -1);
    }

    if (node.attribs["data-is-multicolumn"] === "true" || isStandAlone) {
      return (
        <>
          <GenericTable
            setIsDialogOpen={setIsDialogOpen}
            setTableData={setTableData}
            children={tableXHTML}
            inlineTable={children} //temporary variable until content is released
            tableText={tableText}
            tableCaption={tableCaption}
            isStandAlone={isStandAlone}
            withBackground={true}
            tableId={tableId}
            affordance={affordances.INLINE_TOPIC}
          />
          <StyledTableForPrint className="HiddenTable">
            {children}
          </StyledTableForPrint>
        </>
      );
    }

    return ContentFormatter.processDefaultNode(node, children);
  };

  return { processTable };
};

export default tableProcessor;
